module.exports = __webpack_public_path__ + "static/media/mylab-thumb.aee0bf50.png";